// src/tokens/themes/light/colors.ts
var colorBaseNeutralWhite = "#ffffff";
var colorBaseOrange400 = "#f76708";
var colorBrandPrimaryDefault = "#00b14f";
var colorBackgroundTranslucentInverse = "rgba(26, 26, 26, 0.6)";
var colorContentTextLinkDefault = "#136fd8";
var colorStatusAlertDefault = "#d42e1c";
var colorStatusInformativeDefault = "#136fd8";
var colorStatusPositiveDefault = "#00b14f";
var colorStatusNoticeDefault = "#f09800";
var colorStatusNeutralDefault = "#707070";

// src/tokens/gds-colors.ts
var gdsColorIntegrityTeal200 = "#0fd4db";
var gdsColorDuxtonBlue200 = "#84d2ca";

// src/colors.ts
var colorPrimary = colorBrandPrimaryDefault;
var colorSuccess = colorStatusPositiveDefault;
var colorWarning = colorStatusNoticeDefault;
var colorError = colorStatusAlertDefault;
var colorInfo = colorStatusInformativeDefault;
var colorLink = colorContentTextLinkDefault;
var colorNeutral = colorStatusNeutralDefault;
var colorOrange = colorBaseOrange400;
var colorTeal = gdsColorIntegrityTeal200;
var colorDuxtonBlue = gdsColorDuxtonBlue200;
var colorBgMask = colorBackgroundTranslucentInverse;
var colorWhite = colorBaseNeutralWhite;

// src/tokens/duxton-typography.ts
var gdsFontFamilyPrimary = "Inter";

// src/typography.ts
var fontFamily = `${gdsFontFamilyPrimary} Variable, ${gdsFontFamilyPrimary}, Arial, san-serif`;

export { colorBgMask, colorDuxtonBlue, colorError, colorInfo, colorLink, colorNeutral, colorOrange, colorPrimary, colorSuccess, colorTeal, colorWarning, colorWhite, fontFamily };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.js.map